import { Typography, styled } from '@mui/material'
import {
  ColorOakSwatchMap,
  Model,
  SteelLegsSwatchMap,
  TopColorCeramicSwatchMap,
  TopColorFenixSwatchMap,
} from 'algu-domain'
import { P, match } from 'ts-pattern'

import { useLocalizable } from '@salsita-ai/platform-project-sdk/react'

const SwatchLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  nowrap: true,
  paddingBottom: theme.spacing(1.5),
  variant: 'caption',
}))

export const TopColorSwatchLabel = ({ swatchKey }: { swatchKey: Model.TopColor }) => {
  const { swatchName } = match(swatchKey)
    .with(P.when(Model.TopColorCeramic.is), key => TopColorCeramicSwatchMap[key])
    .with(P.when(Model.TopColorFenix.is), key => TopColorFenixSwatchMap[key])
    .with(P.when(Model.ColorOak.is), key => ColorOakSwatchMap[key])
    .exhaustive()
  const title = useLocalizable(swatchName)

  return <SwatchLabel>{title}</SwatchLabel>
}

export const OakLegsColorSwatchLabel = ({ swatchKey }: { swatchKey: Model.ColorOak }) => {
  const { swatchName } = ColorOakSwatchMap[swatchKey]
  const title = useLocalizable(swatchName)

  return <SwatchLabel>{title}</SwatchLabel>
}

export const SteelLegsColorSwatchLabel = ({ swatchKey }: { swatchKey: Model.LegsColorSteel }) => {
  const { swatchName } = SteelLegsSwatchMap[swatchKey]
  const title = useLocalizable(swatchName)

  return <SwatchLabel>{title}</SwatchLabel>
}
